import React, { useState } from 'react';
import { useCameraViewContext } from '../../context';
import styled from 'styled-components';
import { useField } from 'react-final-form';
import { useFieldArray } from 'react-final-form-arrays';
import { useBackgroundImage } from 'pages/ListerVehicleUploadV2/hooks/useBackgroundImage';

const Wrapper = styled.div<{ imageUrl: string }>`
  width: 100%;
  height: auto;
  aspect-ratio: 4 / 3;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  display: flex;
  flex-direction: column;
  position: relative;

  @media (orientation: landscape) {
    background-size: contain;
    background-position: center;
    aspect-ratio: auto;
    height: 100%;
  }
`;

type Props = {
  children: React.ReactNode;
};

export const ImagePreview = ({ children }: Props) => {
  const { currentImageSrc, level1SectionId, imageIndex } = useCameraViewContext();

  const {
    input: { value: url }
  } = useField(`${level1SectionId}.images.${imageIndex}.url`);
  const {
    input: { value: localUrl, onChange: changeLocalUrl }
  } = useField(`${level1SectionId}.images.${imageIndex}.local_url`);

  const imageUrl = useBackgroundImage({
    localUrl,
    serverUrl: url,
    onServerLoaded: () => {
      if (localUrl) {
        URL.revokeObjectURL(localUrl);
        changeLocalUrl('');
      }
    }
  });

  if (!currentImageSrc && !imageUrl) return null;

  return <Wrapper imageUrl={currentImageSrc || imageUrl}>{children}</Wrapper>;
};
